module.exports = __webpack_public_path__ + "media/customizations/furstranch/logo-new-10c9204a22c634eedc22a7fffb23b3d3.png";